//
//
//
//
//
//

import Login from '@/components/loginCaptcha'
import { mapActions } from 'vuex'
export default {
  name: 'login',
  props: [],
  components: {
    Login
  },
  data () {
    return {
      loginTitle: '迎新注册离校',
      userInfo: {
        account: '',
        password: '',
        captcha: '',
        uuid: '',
        userType: 0
      },
      flowInfo: {
        flowId: '',
        flowType: ''
      },
      studentId: '',
      isBtnLoading: false
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['LoginAction', 'userInfoAction', 'flowInfoAction']),
    refresh () {
      this.$router.go(0)
    },
    getUserInfo (data) {
      this.userInfo.account = data.username
      this.userInfo.password = data.password
      this.userInfo.captcha = data.captcha
      this.userInfo.uuid = data.uuid
    },
    submitLogin () {
      if (!this.isBtnLoading) {
        if (this.userInfo.account === '' || this.userInfo.password === '') {
          this.$vux.toast.text('请输入账号密码', 'top')
          this.$refs.child.getCaptcha()
        } else {
          this.isBtnLoading = true
          let params = this.userInfo
          this.$api.post('/login/token', params,
            r => {
              this.isBtnLoading = false
              this.getAfterLogin().then(() => {
                this.$store.dispatch('userInfoAction', this.userInfo)
              })
              this.userToken = r.data.access_token
              this.$store.dispatch('LoginAction', this.userToken)
              this.$vux.toast.text('登录成功', 'top')
              setTimeout(() => {
                this.$router.push({'name': 'home'})
              }, 300)
            },
            err => {
              this.isBtnLoading = false
              this.$vux.toast.text(err.message, 'top')
              this.$refs.child.getCaptcha()
            })
        }
      }
      setTimeout(() => {
        this.isBtnLoading = false
      }, 20000)
    },
    getAfterLogin () {
      return new Promise((resolve, reject) => {
        this.$api.get('/user/afterLogin', null,
          r => {
            if (r.data.flowBean) {
              this.flowInfo = {
                flowId: r.data.flowBean.id,
                flowType: r.data.flowBean.flowType
              }

              this.$store.dispatch('flowInfoAction', this.flowInfo)
            } else {
              this.$vux.alert.show({
                title: '当前时间您不在办理流程中',
                content: '请于流程开始后再访问',
                onShow () {
                  // console.log('Plugin: I\'m showing')
                },
                onHide () {
                  this.$router.push({
                    name: 'login'
                  })
                }
              })
            }
            this.userInfo = r.data.studentBean
             // 用户头像
            this.$set(this.userInfo, 'studentPictureUrl', r.data.studentPictureUrl)
            resolve()
          },
          err => {
            this.$vux.toast.text(err.message, 'top')
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/common/login.vue